/**
 * Calculates percentage to the nearest integer.
 *
 *  - 0 if denominator is 0
 *  - range is [0, 100]
 */
export const calcPercentage = (num: number, den: number): number =>
  den <= 0 ? 100 : Math.max(Math.min(Math.round((num / den) * 100), 100), 0);
